import { render, staticRenderFns } from "./ReviewCourseSidebar.vue?vue&type=template&id=0629a2b7&scoped=true"
import script from "./ReviewCourseSidebar.vue?vue&type=script&lang=js"
export * from "./ReviewCourseSidebar.vue?vue&type=script&lang=js"
import style0 from "./ReviewCourseSidebar.vue?vue&type=style&index=0&id=0629a2b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0629a2b7",
  null
  
)

export default component.exports